import React from 'react';
import { appConstants } from '../constants';

export default class BkdImage extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		let style;
		if(this.props.dataimage) {
			style = {backgroundImage: 'url('+ this.props.src +')'}
		} else {
			style = {backgroundImage: 'url(' + appConstants.MEDIAPATH + '/'+ encodeURIComponent(this.props.src) +')'}
		}
		return (
			<div style={style} className={'component-background-image ' + this.props.className}>
				{this.props.children}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./web-app/components/background-image.jsx